/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireConfigFund } from './QuestionnaireConfigFund';
import {
    QuestionnaireConfigFundFromJSON,
    QuestionnaireConfigFundFromJSONTyped,
    QuestionnaireConfigFundToJSON,
    QuestionnaireConfigFundToJSONTyped,
} from './QuestionnaireConfigFund';
import type { QuestionnaireConfigInvestmentProfile } from './QuestionnaireConfigInvestmentProfile';
import {
    QuestionnaireConfigInvestmentProfileFromJSON,
    QuestionnaireConfigInvestmentProfileFromJSONTyped,
    QuestionnaireConfigInvestmentProfileToJSON,
    QuestionnaireConfigInvestmentProfileToJSONTyped,
} from './QuestionnaireConfigInvestmentProfile';
import type { QuestionnaireConfigRecommendedStrategy } from './QuestionnaireConfigRecommendedStrategy';
import {
    QuestionnaireConfigRecommendedStrategyFromJSON,
    QuestionnaireConfigRecommendedStrategyFromJSONTyped,
    QuestionnaireConfigRecommendedStrategyToJSON,
    QuestionnaireConfigRecommendedStrategyToJSONTyped,
} from './QuestionnaireConfigRecommendedStrategy';

/**
 * 
 * @export
 * @interface QuestionnaireConfig
 */
export interface QuestionnaireConfig {
    /**
     * 
     * @type {Array<QuestionnaireConfigFund>}
     * @memberof QuestionnaireConfig
     */
    funds: Array<QuestionnaireConfigFund>;
    /**
     * 
     * @type {Array<QuestionnaireConfigInvestmentProfile>}
     * @memberof QuestionnaireConfig
     */
    investmentProfiles: Array<QuestionnaireConfigInvestmentProfile>;
    /**
     * 
     * @type {Array<QuestionnaireConfigRecommendedStrategy>}
     * @memberof QuestionnaireConfig
     */
    recommendedStrategies: Array<QuestionnaireConfigRecommendedStrategy>;
}

/**
 * Check if a given object implements the QuestionnaireConfig interface.
 */
export function instanceOfQuestionnaireConfig(value: object): value is QuestionnaireConfig {
    if (!('funds' in value) || value['funds'] === undefined) return false;
    if (!('investmentProfiles' in value) || value['investmentProfiles'] === undefined) return false;
    if (!('recommendedStrategies' in value) || value['recommendedStrategies'] === undefined) return false;
    return true;
}

export function QuestionnaireConfigFromJSON(json: any): QuestionnaireConfig {
    return QuestionnaireConfigFromJSONTyped(json, false);
}

export function QuestionnaireConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'funds': ((json['funds'] as Array<any>).map(QuestionnaireConfigFundFromJSON)),
        'investmentProfiles': ((json['investmentProfiles'] as Array<any>).map(QuestionnaireConfigInvestmentProfileFromJSON)),
        'recommendedStrategies': ((json['recommendedStrategies'] as Array<any>).map(QuestionnaireConfigRecommendedStrategyFromJSON)),
    };
}

export function QuestionnaireConfigToJSON(json: any): QuestionnaireConfig {
    return QuestionnaireConfigToJSONTyped(json, false);
}

export function QuestionnaireConfigToJSONTyped(value?: QuestionnaireConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'funds': ((value['funds'] as Array<any>).map(QuestionnaireConfigFundToJSON)),
        'investmentProfiles': ((value['investmentProfiles'] as Array<any>).map(QuestionnaireConfigInvestmentProfileToJSON)),
        'recommendedStrategies': ((value['recommendedStrategies'] as Array<any>).map(QuestionnaireConfigRecommendedStrategyToJSON)),
    };
}

